import React, { useState } from "react";
import RevampProductsDrawer from "./RevampProductsDrawer";
import { useLeadDetailsComponent } from "modules/user_management/store/permissionsStore";
import "../revamp-products.css";

const RevampProductsButton = () => {
  const [drawerVisible, setDrawerVisible] = useState(false);
  const canShow = useLeadDetailsComponent("revamp-products-catalog");

  if (!canShow) return null;

  return (
    <>
      <button
        className="revamp-products-btn"
        onClick={() => setDrawerVisible(true)}
      >
        <span className="revamp-products-btn__sparkle">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 0L14.59 8.41L23 11L14.59 13.59L12 22L9.41 13.59L1 11L9.41 8.41L12 0Z" />
          </svg>
        </span>
        <span>Revamp Products</span>
      </button>
      <RevampProductsDrawer
        visible={drawerVisible}
        onClose={() => setDrawerVisible(false)}
      />
    </>
  );
};

export default RevampProductsButton;
